module.exports = __webpack_public_path__ + "entry-150bfe9b/ralph-ostermeier-photo-e5549c724c546f9cf8669eb33f0016de.webp";